import React from "react";
import { PageHero, PageBody } from "./_shared";
import { useRoe } from "./RoeLayout";
import FacilitiesGrid from "@/components/FacilitiesGrid";

export default function Facilities() {
  const data = useRoe();
  const items = data?.facilities || [];
  return (
    <div data-testid="roe-facilities">
      <PageHero eyebrow="Campus" title="World-class Facilities" accent="navy" />
      <PageBody>
        <FacilitiesGrid
          items={items}
          testidPrefix="roe-facilities"
          cardClassName="bg-white border-2 border-[#D4A017]/40 overflow-hidden"
          accentChipClass="bg-[#D4A017]/10 text-[#001F3F] ring-1 ring-[#D4A017]/30"
        />
      </PageBody>
    </div>
  );
}
